module.exports = __webpack_public_path__ + "img/booster1.2ed29ea5.png";